module.exports = __webpack_public_path__ + "Flaticon.e24e6d0b9ee9b81b555c.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/flaticon/Flaticon.woff
// module id = ../../../../../src/assets/vendors/base/fonts/flaticon/Flaticon.woff
// module chunks = styles